export default __webpack_public_path__ + "static/desktop_sek2_KV17-bfd2d82c831387e10d4e8341c0e90b06.mp4";